import { createSlice } from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';
import { SelectedAddress } from './Address.types';
import {
  normalizeDeliveryAddress,
  sameDeliveryDestination,
} from '../../../../../../util/deliveryAddress';
import { persistDeliveryAddress } from '../../../../../../util/deliveryAddressStorage';

export const INITIAL_STATE = {
  selectedAddress: null as SelectedAddress | null,
  selectionInitialized: false,
  intentRevision: 0,
  intentAnchor: null as SelectedAddress | null,
};

const mainSlice = createSlice({
  name: 'address',
  initialState: { ...INITIAL_STATE },
  reducers: {
    setSelectedAddress(state, action) {
      const selectedAddress = normalizeDeliveryAddress(action.payload);
      if (
        state.selectionInitialized &&
        isEqual(state.selectedAddress, selectedAddress)
      )
        return state;
      persistDeliveryAddress(selectedAddress);
      const anchor = state.intentAnchor || state.selectedAddress;
      const equivalent =
        anchor &&
        selectedAddress &&
        sameDeliveryDestination(anchor, selectedAddress);
      return {
        ...state,
        selectedAddress,
        intentAnchor: equivalent ? anchor : selectedAddress,
        intentRevision: (state.intentRevision || 0) + (equivalent ? 0 : 1),
        selectionInitialized: true,
      };
    },
    restoreSelectedAddress(state, action) {
      if (state.selectionInitialized || state.selectedAddress) return state;
      return {
        ...state,
        selectedAddress: normalizeDeliveryAddress(action.payload),
        selectionInitialized: true,
      };
    },
  },
});

export const { setSelectedAddress, restoreSelectedAddress } = mainSlice.actions;

export default mainSlice.reducer;
